import request from 'utils/request'

// 文件类型select查询
export const getSelectList = () => request().get('document/type/list')

// 获取table数据
export const getTableData = data => request().post('document/page', data)

// 下载文件
export const download = id =>
  request().get(`document/download/${id}`, { responseType: 'blob' })

// 删除文件
export const deleteDocument = id => request().get(`document/delete/${id}`)

// 新增或者更新文件夹数据
export const updateDocument = data =>
  request().post('document/upload', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// 删除上传文件
export const removeUploadDocument = id =>
  request().get(`document/deleteFile/${id}`)

export const checkIsAdmin = () => request().get('credit/roleExist')
